import type { UseFetchOptions } from 'nuxt/app'
import { useLogger } from '../composables/useLogger'
import { useApiService } from '../composables/useApiService'

export interface ProviderRequest {
    auth_id: string
}

export interface ProviderResponse {
    // the response will be an array of users with a list of roles as json
    provider: string
    success: boolean
    version: number
    environment: string
    timestamp: string
}

export function useGetProviderService() {
    const logger = useLogger()
    const { makeApiCall, forceTestVsTestServer } = useApiService()

    const getProvider = async (providerRequest: ProviderRequest, options?: UseFetchOptions<ProviderResponse>) => {
        logger.debug('GetProviderService: Getting provider', { providerRequest })

        const provider = await makeApiCall<ProviderRequest, ProviderResponse>(
            'auth/get-person-provider',
            providerRequest,
            'GetProviderService',
            options
        )

        logger.debug('GetProviderService: Got provider', { provider })

        return provider
    }

    return {
        forceTestVsTestServer,
        getProvider
    }
} 